export const associationRenderer = (
  _instance,
  td,
  _row,
  _col,
  _prop,
  value,
) => {
  if (value == null || !value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  td.innerHTML = `<div class="truncated">${value.name}</div>`;
  return td;
};
